import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    product: {},
    isMenuFormulaSaleOpen: false,
    menuFormulaIdsList: [],
    formulaPrincipalItemPrice: 0,
    initialItem: {},
    isBeforeMenu: false,
    formulaMenuTitle: "",
    activeSizeDialogProductId: "",
};

export const ProductSlice = createSlice({
    name: "ProductSlice",
    initialState,
    reducers: {
        SelectProduct: (state, action) => {
            state.product = action.payload;
            state.isMenuFormulaSaleOpen = false;
        },
        setMenuFormulaSaleData: (state, { payload }) => {
            state.isMenuFormulaSaleOpen = payload.isMenuFormulaSaleOpen;
            state.menuFormulaIdsList = payload.menuFormulaIdsList;
            state.formulaPrincipalItemPrice = payload.formulaPrincipalItemPrice;
            state.initialItem = payload.initialItem;
            state.isBeforeMenu = payload.isBeforeMenu;
            state.formulaMenuTitle = payload.formulaMenuTitle;
        },
        setActiveSizeDialogProductId(state, { payload }) {
            state.activeSizeDialogProductId = payload;
        },
    },
});

export const {
    SelectProduct,
    setMenuFormulaSaleData,
    setActiveSizeDialogProductId,
} = ProductSlice.actions;
export default ProductSlice.reducer;
